/* QUELL — range-grid: chip category filter + optional client-side pager. Split from theme.js. */
(function () {
  "use strict";
  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  /* ── Range grid — chip category filter (moved from sections/range-grid.liquid).
     Re-scoped from #shopify-section-{{id}} to the [data-range-grid-root] wrapper;
     count labels are read from data-count-one/-other so the words stay localised.

     Paging is done here rather than with Liquid's `paginate` because the chips
     filter cards that are already in the DOM — a server-side page would only ever
     slice the unfiltered set, so chip + page would disagree. data-per-page of 0
     (the default) keeps every card visible and never renders the pager, which is
     the behaviour pages/ranges relies on. */
  function initRangeGrid(root) {
    if (!root) return;
    var chips = root.querySelector("[data-range-chips]");
    var cards = Array.prototype.slice.call(
      root.querySelectorAll("[data-range-grid] .card"),
    );
    var count = root.querySelector("[data-range-count]");
    var empty = root.querySelector("[data-range-empty]");
    var pager = root.querySelector("[data-range-pager]");
    var grid = root.querySelector("[data-range-grid]");
    var oneWord = root.getAttribute("data-count-one") || " product";
    var otherWord = root.getAttribute("data-count-other") || " products";
    var prevWord = root.getAttribute("data-prev-label") || "Previous";
    var nextWord = root.getAttribute("data-next-label") || "Next";
    var perPage = parseInt(root.getAttribute("data-per-page"), 10);
    if (!perPage || perPage < 1) perPage = 0;

    var filter = "all";
    var page = 1;

    function matching() {
      return cards.filter(function (c) {
        return filter === "all" || c.getAttribute("data-cat") === filter;
      });
    }

    function buildPager(totalPages) {
      if (!pager) return;
      pager.textContent = "";
      if (perPage === 0 || totalPages < 2) {
        pager.hidden = true;
        return;
      }
      pager.hidden = false;

      function btn(label, targetPage, opts) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "range-pager__btn" + (opts && opts.current ? " on" : "");
        b.textContent = label;
        if (opts && opts.current) b.setAttribute("aria-current", "page");
        if (opts && opts.disabled) b.disabled = true;
        b.addEventListener("click", function () {
          page = targetPage;
          render(true);
        });
        pager.appendChild(b);
      }

      btn(prevWord, Math.max(1, page - 1), { disabled: page === 1 });

      /* Window the numbers so a long list does not become its own scroll problem. */
      var start = Math.max(1, page - 2);
      var end = Math.min(totalPages, start + 4);
      start = Math.max(1, Math.min(start, end - 4));

      if (start > 1) {
        btn("1", 1, {});
        if (start > 2) {
          var gapL = document.createElement("span");
          gapL.className = "range-pager__gap";
          gapL.textContent = "…";
          pager.appendChild(gapL);
        }
      }
      for (var i = start; i <= end; i++) {
        btn(String(i), i, { current: i === page });
      }
      if (end < totalPages) {
        if (end < totalPages - 1) {
          var gapR = document.createElement("span");
          gapR.className = "range-pager__gap";
          gapR.textContent = "…";
          pager.appendChild(gapR);
        }
        btn(String(totalPages), totalPages, {});
      }

      btn(nextWord, Math.min(totalPages, page + 1), {
        disabled: page === totalPages,
      });
    }

    function render(scroll) {
      var shownCards = matching();
      var total = shownCards.length;
      var totalPages = perPage ? Math.ceil(total / perPage) || 1 : 1;
      if (page > totalPages) page = totalPages;
      if (page < 1) page = 1;

      var from = perPage ? (page - 1) * perPage : 0;
      var to = perPage ? from + perPage : total;

      cards.forEach(function (c) {
        c.classList.add("hide");
      });
      shownCards.slice(from, to).forEach(function (c) {
        c.classList.remove("hide");
      });

      /* The count is the size of the filtered set, not of the page — the pager
         already says which slice of it is on screen. */
      if (count) count.textContent = total + (total === 1 ? oneWord : otherWord);
      if (empty) empty.hidden = total !== 0;
      buildPager(totalPages);

      if (scroll && grid) {
        var top = grid.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: top > 0 ? top : 0, behavior: "smooth" });
      }
    }

    if (chips) {
      chips.addEventListener("click", function (e) {
        var b = e.target.closest(".chip-btn");
        if (!b) return;
        chips.querySelectorAll(".chip-btn").forEach(function (x) {
          x.classList.remove("on");
        });
        b.classList.add("on");
        filter = b.getAttribute("data-f");
        page = 1;
        render(false);
      });
    }

    render(false);
  }

  ready(function () {
    document.querySelectorAll("[data-range-grid-root]").forEach(function (el) {
      initRangeGrid(el);
    });
  });
  document.addEventListener("shopify:section:load", function (e) {
    var rg =
      e.target.querySelector &&
      e.target.querySelector("[data-range-grid-root]");
    if (rg) {
      initRangeGrid(rg);
    }
  });
})();
